import createGetFormSyncErrors from './selectors/getFormSyncErrors';
import plain from './structure/plain';

export default createGetFormSyncErrors(plain);


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/redux-form/es/getFormSyncErrors.js
// module id = 1219
// module chunks = 4